import React, { useEffect, useState } from 'react'
import API_KEY from "./key"

const CONTEXT_KEY = "79076af78460aa045";
const useGoogleSearch = (term) => {
    const [data,setData] = useState(null);
    useEffect(() => {
        const fetchdata =async()=>{
            fetch(`https://www.googleapis.com/customsearch/v1?key=${API_KEY}&cx=${CONTEXT_KEY}&q=${term}`)
            .then(response=>response.json())
            .then(result=>setData(result));

        }
        fetchdata().then(res=>{
            console.log(res)
        })

        
    }, [term])
    return{
        data
    };
   
}

export default useGoogleSearch
